import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../services/auth.service';
import { Login } from './login';
import{ BehaviorSubject} from'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  validateForm!: UntypedFormGroup;

  private loggedIn= new BehaviorSubject<boolean>(false);
  
  constructor(    
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private authService: AuthService) {}

    submitForm(): void {
      for (const i in this.validateForm.controls) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
  
      if(this.validateForm.valid){
        let id = this.message.loading('Validando...').messageId;
        this.authService.login(this.validateForm.value.email, this.validateForm.value.password).subscribe((l: any) => {
          let login = new Login;
          this.loggedIn.next(true);
          login.login(l);
          //Guarda as informações do usuario logado
          this.authService.me().subscribe((m: any) => {
            let save = new Login();
            save.setInfoUsuario(m);
            this.message.remove(id);
            this.router.navigate(['/inicio']);
          });
    
        }, (err: any) => {
          this.message.remove(id);
          this.message.error(err['error']['error']);
        });
      }
    }
    
    ngOnInit(): void {
      this.validateForm = this.fb.group({
        email: [null, [Validators.email, Validators.required]],
        password: [null, [Validators.required]],
      });
    }

}
